import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import ValidationDetails from './ValidationDetails';

export default class ListValidation extends Component {
  static propTypes = {
    validations: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };

  render() {
    const {
      validations,
      showValidationDeleteLoader,
      projectId,
      collection,
      actions,
      commonActions,
      version,
      flag,
      isReadOnly,
    } = this.props;
    if (validations && validations.length > 0) {
      return (
        <div className="row modal-scroll">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <Accordion allowZeroExpanded>
              {validations.map((rule) => (
                <AccordionItem key={rule.customValidationName}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb`}></i> <strong>{rule.customValidationName}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <ValidationDetails
                      rule={rule}
                      showValidationDeleteLoader={showValidationDeleteLoader}
                      projectId={projectId}
                      version={version}
                      collection={collection}
                      actions={actions}
                      commonActions={commonActions}
                      flag={flag}
                      isReadOnly={isReadOnly}
                    />
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      );
    } else
      return (
        <div>
          <h5 className="text-center">No Validations!</h5>
        </div>
      );
  }
}
